import React from 'react';
import { QuestionMark } from '@mui/icons-material';
import { ExpandableCard, Icon, Row, Stack, Text } from 'library/ui';
import { PaymentFaq } from './paymentFaqs';

export default function PaymentFaqList({ faqs }: { faqs: PaymentFaq[] }) {
    return (
        <Stack gap="sm">
            {faqs.map((faq) => (
                <ExpandableCard
                    key={faq.question}
                    header={
                        <Row gap="sm" align="center">
                            <Icon icon={QuestionMark} size="sm" />
                            <Text weight="semibold">{faq.question}</Text>
                        </Row>
                    }
                >
                    <Text size="sm">{faq.answer}</Text>
                </ExpandableCard>
            ))}
        </Stack>
    );
}
